import Vue from 'vue'

function setErrorClassToForm(errorKeys) {
  if (errorKeys.length > 0) {
    errorKeys.map((v) => {
      const nodeList = document.querySelectorAll('input[name='+v+'],textarea[name='+v+'],select[name='+v+']')
      if (nodeList) {
        for (let form of nodeList) {
          form.classList.add("error")
        }
      }
    })
  }
}

function scrollToFirstError() {
  const el = document.querySelector('.error')
  if (el) {
    el.scrollIntoView()
  }
}

export default (data) => {
  const vm = new Vue({
    el: '#form_container',
    data: data,
    methods: {
      getIndex: function(list, key, addnum){
        // objectの何番目のキーであるかを返す。
        let retidx = 0 + addnum;
        Object.keys(list).some(function(i){
          if(i===key) {
            return true;
          }
          retidx++;
        });
        return retidx;
      },
      convertAndSortObject: function (list) {
        // selectなどで、未選択の場合keyが文字列(--など)だが、他選択は数値となる場合に、
        // js仕様で 数値->文字列 の順に並んでしまうので、文字列->数値の順で並べられるよう
        // ソートしたObjectで返す
        var array = Object.keys(list).map((k)=>({ key: k, value: list[k] }));
        array.sort(function(prev, next) {
          var ret = 0;
          if(isNaN(prev.key) || (prev.key === '')) {
            ret = -1;
          } else if(isNaN(next.key)|| (prev.key === '')) {
            ret = 1;
          }
          return ret;
        });
        return array;
      }
    },
      watch: {
         'form.zip': function(zip) {
              let _this = this;
             if (8 != zip.length) {
                 return;
             }
              new window.YubinBango.Core(zip, function(addr) {
                  _this.form.pref  = addr.region_id // 都道府県ID
                  _this.form.address1 = addr.locality +  addr.street // 市区町村
              })
          }
      },
      computed: {
      fee: function() {
      }
    },
    mounted: function() {
      setErrorClassToForm(this.errors)
      scrollToFirstError()
    }
  })
}
